/* eslint-disable eqeqeq */
/* eslint-disable no-plusplus */
/* eslint-disable guard-for-in */
/* eslint-disable no-continue */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-console */
/* eslint-disable-next-line  */
/* no-prototype-builtins  */
import { css, html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';

import { i18nMixin, responsiveMixin } from '@kisters/wcp-base/decorators';
import dayjs from '@kisters/wcp-base/common/dayjsext';
import { orderBy, find } from 'lodash-es';
import Highcharts from 'highcharts/highstock';
import more from 'highcharts/highcharts-more';

import exporting from 'highcharts/modules/exporting';
import hclocales from '@kisters/wcp-water/common/highcharts-locales.js';
import offlineExport from 'highcharts/modules/offline-exporting';
import { template, Mix } from '@kisters/wcp-base/common';
import '@kisters/wcp-base/components/ki-icon/ki-icon-btn';
import '@kisters/wiski-web/components/ki-wwp-graph/ki-wwp-ts-table';
import boost from 'highcharts/modules/boost';

import { getCurrentApi } from '@kisters/wiski-web/api';
import { getRouteOptionsAndParams } from '@kisters/wcp-base/components';
import nls from '../locales/index';

more(Highcharts);
exporting(Highcharts);
offlineExport(Highcharts);
// boost(Highcharts);

const Util = {
  undefined(obj) {
    return !(obj !== undefined);
  },
  defined(obj) {
    return obj !== undefined && obj !== null;
  },
  IsArray(obj) {
    return obj && obj instanceof Array;
  },
  ToArray(val) {
    // eslint-disable-next-line no-nested-ternary
    return this.IsArray(val) ? val : this.IsNullOrEmpty(val) ? [] : [val];
  },
  IsNullOrEmpty(obj) {
    let rtc = !Util.defined(obj) || String(obj).length === 0;
    if (!rtc && obj instanceof Object) {
      rtc = true;
      // eslint-disable-next-line no-restricted-syntax, guard-for-in, no-empty-pattern
      for (const key in obj) rtc = false;
    }
    return rtc;
  },
  // eslint-disable-next-line consistent-return
  pick(obj) {
    // eslint-disable-next-line prefer-rest-params
    const args = arguments;
    let i;
    let arg;
    const { length } = args;
    // eslint-disable-next-line no-plusplus
    for (i = 0; i < length; i++) {
      arg = args[i];
      if (arg !== undefined && arg !== null) {
        return arg;
      }
    }
  },
};

export default class WwpEpmpGraph extends Mix(
  LitElement,
  [i18nMixin, { nls }],
  responsiveMixin,
) {
  // language=CSS
  static styles = css`
    :host {
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }

    :host(.sm-screen) .contentnode {
      min-height: 500px;
    }
    :host(.sm-screen.LANDSCAPE) .contentnode {
      margin-bottom: 50px;
    }
    .contentnode {
      display: flex;
      flex: 1;
    }
    #table-wrapper {
      position: relative;
      overflow: auto;
      flex: 0 0 220px;
    }

    #table-wrapper.hidden {
      position: relative;
      overflow: auto;
      flex: 0 0 0;
    }

    ki-wwp-ts-table {
      position: absolute;
      height: 100%;
      width: 100%;
    }

    #chart-node {
      display: table-cell;
      position: absolute;
      width: 100%;
      height: 100%;
    }

    #chart-wrapper {
      position: relative;
      flex: 1;
      margin-right: 10px;
    }

    .highcharts-exporting-group {
      cursor: pointer;
    }
    * {
      font-family: 'Source Sans Pro', sans-serif;
    }
    .highcharts-contextmenu .highcharts-menu-item {
      font-size: 12pt !important;
    }

    :host(.sm-screen) #table-wrapper.hidden {
      position: relative;
      overflow: auto;
      flex: 0 0 0px;
    }

    :host(.sm-screen) #table-wrapper {
      margin-top: 25px;
      flex: 1 1 100%;
      background: white;
    }

    :host(.sm-screen) ki-icon-btn {
      right: 20px;
    }
    ki-icon-btn {
      position: absolute;
      right: 10px;
      top: 15px;
      z-index: 5;
    }
    ki-icon-btn[active] {
      right: 230px;
    }
  `;

  @property({ attribute: false })
  highcharts = Highcharts;

  api = getCurrentApi();

  constructor() {
    // Always call super() first
    super();

    // Initialize properties
    this.tableOpen = true;
    this.dateFormat = 'L';
    this.dateTimeFormat = 'L';
    this.yAxisType = 'linear';
  }

  async onAfterEnter(location, options, router) {
    Object.assign(this, location.params);
    const params = getRouteOptionsAndParams(location, []);
    Object.assign(this, params.options);
    this.fetchData();
    this.refreshInterval = setInterval(() => {
      this.fetchData();
    }, 300000);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    clearInterval(this.refreshInterval);
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.renderRoot.host.classList.contains('sm-screen')) {
      this.tableOpen = false;
    }
    this.numberFormatter = new Intl.NumberFormat(
      this.i18n.language,
      this.numberFormat || {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      },
    );
  }

  createChart() {
    if (hclocales[this.i18n.language]) {
      this.highcharts.setOptions({
        plotOptions: {
          series: {
            animation: false,
          },
        },
        lang: hclocales[this.i18n.language],
      });
    }
    this.chart = new this.highcharts.Chart(
      this.chartOptions(),
      this.chartCreated.bind(this),
    );
  }

  chartOptions() {
    const now = new Date();
    const { dateFormat } = this;
    const buttons = this.highcharts
      .getOptions()
      .exporting.buttons.contextButton.menuItems.filter(item => {
        const fullScreenAvailable =
          document.fullscreenEnabled ||
          document.mozFullscreenEnabled ||
          document.webkitFullscreenEnabled ||
          document.msFullscreenEnabled;
        if (this.classList.contains('sm-screen')) {
          return item === 'viewFullscreen' && fullScreenAvailable;
        }
        return true;
      });
    const colors = ['darkred', 'darkblue', 'green', 'orange'];

    return {
      chart: {
        renderTo: this.renderRoot.querySelector('#chart-node'),
        animation: false,
        zoomType: 'x',
        events: {
          beforePrint() {
            this.setSize(1024, 700, false);
          },
          afterPrint() {
            this.setSize(null, null, false);
          },
          load() {
            this.renderer
              .image(
                'data:image/png;base64,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',
                10,
                0,
                160,
                74,
              )
              .add();
          },
        },
      },

      legend: {
        useHTML: false,
        symbolPadding: 7,
        alignColumns: false,
        itemDistance: 20,
        itemMarginTop: 10,
        labelFormatter() {
          const { legend } = this.chart;
          const label = this.name;
          console.log(
            label,
            this.options.legendNewLine,
            this.options.legendGroupBlock,
          );
          if (legend && this.options.legendGroupBlock) {
            //   this.legendItem.css({"color": colors[count]});
            this.legendGroup.on('mouseover', () => {});
            this.legendGroup.on('mouseout', () => {});
          }
          const color = this.visible
            ? colors[this.options.legendGroupIndex]
            : '#cccccc';
          return `<span style="color:${color}">${label}</span>`;
        },
      },
      exporting: {
        fallbackToExportServer: false,
        scale: 1,
        sourceWidth: 1920,
        sourceHeight: 1080,
        chartOptions: {
          chart: {
            events: {
              load() {
                this.renderer
                  .image(
                    'data:image/png;base64,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',
                    10,
                    0,
                    160,
                    74,
                  )
                  .add();
              },
            },
          },
          legend: {
            useHTML: false,
            alignColumns: false,
            symbolPadding: 17,
            itemDistance: 60,
            itemStyle: {
              color: '#333333',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 'bold',
            },
          },
        },
        filename: `${this.station.station_name}_graphique`,
        printMaxWidth: 1024,
        enabled: true,
        buttons: {
          contextButton: {
            enabled: buttons.length > 0,
            menuItems: buttons,
            y: 15,
            x: -60,
            symbolSize: 15,
          },
        },
      },
      time: {
        useUTC: false,
      },
      title: { text: `${this.station.station_name}` },
      subtitle: {
        text: `${this.station.AD_TYPE_POINT} suivi depuis ${
          this.station.AD_DEBUT_SUIVI
        } <br>Producteur : ${this.station.AD_PRODUCTEUR} ${
          this.station.AD_TEXTELIBRE_WEB
            ? `<br><b style="color:red;">${this.station.AD_TEXTELIBRE_WEB}</b>`
            : ''
        }`,
      },
      xAxis: {
        ordinal: false,
        type: 'datetime',
        min: this.noMinMax
          ? null
          : new Date(now.getFullYear(), 0, 1, 0, 0).getTime(),
        max: this.noMinMax
          ? null
          : new Date(now.getFullYear(), 11, 31, 23, 59, 59).getTime(),
        labels: {
          style: {
            fontSize: '14px',
          },
          formatter() {
            const { _overlaidPlots } = this.chart.options;
            return dayjs(this.value).format(
              _overlaidPlots ? 'DD/MM' : dateFormat,
            );
          },
        },
        events: {
          afterSetExtremes() {
            //    _t._getTable(_t._showInTable, this.min, this.max);
          },
        },
      },
      yAxis: {
        type: this.yAxisType,

        title: { text: this.yAxisLabel },
        labels: {
          style: {
            fontSize: '14px',
          },
        },
      },
      tooltip: {
        shared: true,
        xDateFormat:
          this.dateTimeFormat === 'L' ? '%A, %b %e, %Y' : '%A, %b %e, %H:%M',
      },
      plotOptions: {
        series: {
          animation: false,
          gapSize: 2,
          marker: { enabled: false },
          label: { enabled: false },
        },
        arearange: {
          tooltip: {
            pointFormat:
              '<span style="color:{series.color}">●</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>',
          },
        },
      },
      credits: { enabled: false },
    };
  }

  chartCreated(chart) {
    const e = new CustomEvent('load', {
      detail: chart,
    });
    this.dispatchEvent(e);
  }

  updated() {
    if (this.chart) {
      this.chart.reflow();
    }
  }

  render() {
    return html`<div class="contentnode">
      <ki-icon-btn
        toggle
        title="Tabelle"
        icon="ki ki-table"
        ?active="${this.tableOpen}"
        @click="${this.showTable}"
      ></ki-icon-btn>
      <div id="chart-wrapper">
        <div id="chart-node"></div>
      </div>
      <div id="table-wrapper" class="${this.tableOpen ? '' : 'hidden'}">
        <ki-wwp-ts-table
          id="dataTable"
          .columns="${this.tablecolumns}"
          sort='[{"field":"timestamp", "ascending":false}]'
          idproperty="timestamp"
        >
        </ki-wwp-ts-table>
      </div>
    </div>`;
  }

  showTable() {
    this.renderRoot.querySelector('#table-wrapper').classList.toggle('hidden');
    this.tableOpen = !this.tableOpen;
    this.chart && this.chart.reflow();
  }

  get tablecolumns() {
    return [
      {
        field: 'timestamp',
        label: 'Horodatage',
        sortable: true,
        hideAble: false,
      },
      {
        field: 'value',
        label: this.yTableLabel || 'Valeur',
        sortable: false,
      },
    ];
  }

  async fetchData() {
    const _files = {};
    this.tsdata = [];
    const { yAxisType } = this;
    this.station = this.station || (await this.api.getStation(this.stationId));
    await Promise.all(
      this.station.timeseries
        .filter(
          ts =>
            ts.station_parameter === this.station_parameter &&
            this.dataFiles.includes(ts.document_key),
        )
        .map(async ts => {
          _files[ts.document_key] = await this.api.getTsData(ts.href);
        }),
    );
    for (const [key, value] of Object.entries(_files)) {
      this.tsdata.push(...value);
    }
    this.tsdata.forEach(item => {
      const series = [];
      const valCol = item.columns.split(',').indexOf('Value');
      item.data.forEach(point => {
        if (
          yAxisType === 'logarithmic' &&
          point[valCol] !== null &&
          point[valCol] <= 0
        ) {
          point[valCol] = 0.001;
        }
        series.push([new Date(point[0]).getTime(), parseFloat(point[valCol])]);
      });
      item.series = series;
    });
    this.files = _files;
    this.createChart();
    this.initData();
  }

  _formatNumber(val) {
    return val === undefined || val === null || val === '' || Number.isNaN(val)
      ? ''
      : this.numberFormatter.format(val);
  }

  initData() {
    const config_list = this.graphs;
    const series_list = [];
    const legendGroups = [];
    for (let h = 0; h < config_list.length; h++) {
      const config = config_list[h];
      let series = null;
      const data = Util.ToArray(this.tsdata);
      for (let i = 0; i < data.length; i++) {
        if (config.type === 'line') {
          if (data[i].ts_shortname === config.ts_shortname) {
            series = data[i].series;
            if (series && config.showInTable) {
              const orderedTableData = orderBy(series, [0], ['desc']).map(
                item => ({
                  timestamp: dayjs(item[0]).format('L'),
                  value: this._formatNumber(item[1]),
                }),
              );
              this.shadowRoot.getElementById('dataTable').data =
                orderedTableData;
            }
            break;
          }
        } else if (config.type === 'arearange') {
          if (data[i].ts_shortname === config.ts_shortname_min) {
            const maxts = find(
              data,
              item => item.ts_shortname === config.ts_shortname_max,
            );
            series = data[i].series;
            series.forEach((point, index) => {
              point.push(maxts.data[index][1]);
            });
            break;
          }
        }
      }
      if (!series) {
        continue;
      }
      const legendGroup = Util.pick(config.legendGroup, null);
      const options = {
        type: config.type,
        data: series,
        name: config.label || config.ts_shortname,
        legendGroup,
      };
      options.name = template(options.name, {
        currentYear: new Date().getFullYear(),
      });
      if (config.dashStyle) {
        options.dashStyle = config.dashStyle;
      }
      if (config.hasOwnProperty('color')) {
        options.color = config.color;
        if (options.type === 'arearange') {
          options.fillColor = config.color;
        }
      }
      if (config.hasOwnProperty('width')) {
        options.lineWidth = config.width;
      }
      if (config.hasOwnProperty('enabled')) {
        options.visible =
          typeof config.enabled === 'string'
            ? this.layerContext === config.enabled
            : config.enabled;
      }
      if (config.hasOwnProperty('zIndex')) {
        options.zIndex = config.zIndex;
      }
      if (config.hasOwnProperty('id')) {
        options.id = config.id;
      }
      if (config.hasOwnProperty('linkedTo')) {
        options.linkedTo = config.linkedTo;
      }
      if (legendGroup) {
        if (legendGroups.indexOf(legendGroup) < 0) {
          const selected = Util.pick(options.visible, true);
          //  add dummy  timeseries for legendGroup
          series_list.push({
            type: 'line',
            data: [],
            name: legendGroup,
            lineWidth: 0,
            // drawLegendSymbol = false,
            /* marker: {
                  symbol: _t.getCheckBoxSymbol(selected),
                  enabled: true,
                  radius: 30
              },
              */
            legendGroupBlock: true,
            legendGroup,
            legendGroupIndex: legendGroups.length,
            visible: selected,
            selected,
            events: {
              legendItemClick() {
                const _legendGroup = this.options.legendGroup;
                const visible = !this.visible;
                // this.symbol = _t.getCheckBoxSymbol(visible);
                this.chart.isDirtyLegend = true;
                this.selected = visible;
                for (const key in {
                  legendItem: 'legendItem',
                  legendSymbol: 'legendSymbol',
                }) {
                  if (this[key]) {
                    this[key] = this[key].destroy();
                  }
                }
                for (let i = 0; i < this.chart.series.length; i++) {
                  if (
                    !this.chart.series[i].options ||
                    !this.chart.series[i].options.legendGroup
                  )
                    continue;
                  if (this.chart.series[i].options.legendGroup == _legendGroup)
                    this.chart.series[i].setVisible(visible);
                }
                return false;
              },
            },
          });
          legendGroups.push(legendGroup);
          options.firstGroupElement = true;
        }
        options.legendGroupIndex = legendGroups.indexOf(legendGroup);
      }
      series_list.push(options);
    }
    let legendIndex = 0;
    for (let step = 0; step < 2; step++) {
      // for (let step =1; step >=0; step --) {
      let legendNewLine = this.chart.series.length > 0;
      if (step === 0) {
        for (let si = 0; si < series_list.length; si++) {
          const options = series_list[si];
          if (!options) continue;
          if (Util.defined(options.legendIndex)) continue;
          if (Util.defined(options.legendGroupIndex)) continue;
          options.legendNewLine = legendNewLine;
          options.legendIndex = legendIndex++;
          this.chart.addSeries(options, false);
          legendNewLine = false;
        }
      } else if (step == 1) {
        let legendGroupIndex = -1;
        for (let si = 0; si < series_list.length; si++) {
          const options = series_list[si];
          if (!options) continue;
          if (Util.defined(options.legendIndex)) continue;
          if (Util.undefined(options.legendGroupIndex)) continue;
          if (legendGroupIndex != options.legendGroupIndex) {
            options.legendNewLine = legendNewLine;
            legendGroupIndex = options.legendGroupIndex;
            legendNewLine = true;
          }
          options.legendIndex = legendIndex + options.legendGroupIndex;
          legendIndex++;
          this.chart.addSeries(options, false);
        }
      }
    }
    this._createOverlaidPlot(legendIndex + 1);
  }

  _createOverlaidPlot(legendIndex) {
    const { yAxisType } = this;
    const { chart } = this;
    const _t = this;
    const now = new Date();
    if (!chart) return;
    const { station_parameter } = this;
    const overlaidPlotConfig = this.overlaidFile;
    if (Util.IsNullOrEmpty(station_parameter)) return;
    if (Util.IsNullOrEmpty(overlaidPlotConfig)) {
      chart.redraw();
      return;
    }

    if (Util.IsNullOrEmpty(this.files[overlaidPlotConfig])) {
      chart.redraw();
      return;
    }

    legendIndex = Util.pick(legendIndex, chart.series.length + 1);

    const currentYear = new Date().getFullYear();
    const rtc = this.files[overlaidPlotConfig];
    if (Util.IsNullOrEmpty(rtc)) return;

    const hmSeries = {};
    let tbl = rtc[0] || [];
    if (tbl.length < 1) return;
    tbl = tbl.series;
    for (let r = 0; r < tbl.length; r++) {
      const timestamp = tbl[r][0];
      let value = tbl[r][1];
      if (!timestamp) continue;
      const dt = new Date(timestamp);
      const year = dt.getFullYear();
      if (year === currentYear) continue;
      if (yAxisType === 'logarithmic' && value !== null && value <= 0) {
        value = 0.001;
      }
      hmSeries[year] = hmSeries[year] || [];
      if (currentYear) dt.setFullYear(currentYear);
      hmSeries[year].push([dt.getTime(), parseFloat(value)]);
    }
    let overlaidPlots = 0;
    for (const year in hmSeries) {
      const series = hmSeries[year];
      if (Util.IsNullOrEmpty(series)) return;
      const options = {
        type: 'line',
        data: series,
        name: String(year),
        visible: false,
        legendNewLine: ++overlaidPlots == 1,
        legendIndex: legendIndex++,
      };
      if (overlaidPlotConfig.hasOwnProperty('dashStyle')) {
        options.dashStyle = overlaidPlotConfig.dashStyle;
      }
      if (overlaidPlotConfig.hasOwnProperty('zIndex')) {
        options.zIndex = overlaidPlotConfig.zIndex;
      }
      if (overlaidPlotConfig.hasOwnProperty('width')) {
        options.lineWidth = overlaidPlotConfig.width;
      }
      chart.addSeries(options, false);
    }
    if (overlaidPlots > 0) {
      chart.options._overlaidPlots = overlaidPlots;
      chart.xAxis[0].setExtremes(
        new Date(now.getFullYear(), 0, 1, 0, 0).getTime(),
        new Date(now.getFullYear(), 11, 31, 23, 59, 59).getTime(),
        false,
      );
      chart.redraw();
    } else {
      chart.redraw();
    }
  }
}

customElements.define('wwp-epmp-graph', WwpEpmpGraph);
